import showrooms from '@/seo/showrooms.json'

const moscowShowroom = showrooms.find(store => store.id === '01')
const kirovShowroom = showrooms.find(store => store.id === '02')

export default {
  namespaced: true,
  state: {
    active: false,
    activePage: 0,
    totalPages: 0,
    openPopup: false,
    sectionsContent: {
      interior: {
        title: 'Объединяя пространства',
        slides: [
          {
            id: 1,
            title: 'Шкафы и гардеробы',
            name: 'Объединяя пространства',
            subtitle: 'Большой выбор стилей',
            desc: 'Индустриальный шик в\u00A0домашнем интерьере',
            image: require('@/assets/img/home/interior/int1.jpg'),
            imageMob: require('@/assets/img/home/interior/int1_mob.jpg')
          },
          {
            id: 2,
            title: 'Ванные комнаты',
            name: 'Объединяя пространства',
            subtitle: 'Lorem ipsum dolor sit amet',
            desc: 'Восхищающие формы нового образа',
            image: require('@/assets/img/home/interior/int2.jpg'),
            imageMob: require('@/assets/img/home/interior/int2_mob.jpg')
          },
          {
            id: 3,
            title: 'Стеновые панели',
            name: 'Объединяя пространства',
            subtitle: 'Lorem ipsum dolor sit amet',
            desc: 'Сдержанная роскошь',
            image: require('@/assets/img/home/interior/int5.jpg'),
            imageMob: require('@/assets/img/home/interior/int3_mob.png')
          }
        ]
      },
      materials: {
        slides: [
          {
            id: '01',
            title: 'Каркас',
            desc: 'Восхищающие формы нового образа',
            image: require('@/assets/img/home/materials/mat_1.jpg'),
            imageMob: require('@/assets/img/home/mob4.jpg')
          },
          {
            id: '02',
            title: 'Фронты',
            subtitle: 'Lorem ipsum dolor sit amet',
            desc: 'Восхищающие формы нового образа',
            image: require('@/assets/img/home/materials/mat_2.jpg'),
            imageMob: require('@/assets/img/home/mob4.jpg')
          },
          {
            id: '03',
            title: 'Столешницы',
            subtitle: 'Lorem ipsum dolor sit amet',
            desc: 'Восхищающие формы нового образа',
            image: require('@/assets/img/home/materials/mat_3.jpg'),
            imageMob: require('@/assets/img/home/mob4.jpg')
          },
          {
            id: '04',
            title: 'Оснащение',
            subtitle: 'Lorem ipsum dolor sit amet',
            desc: 'Восхищающие формы нового образа',
            image: require('@/assets/img/home/materials/mat_4.jpg'),
            imageMob: require('@/assets/img/home/mob4.jpg')
          }
        ],
        background: require('@/assets/img/home/int2.jpg')
      },
      contacts: {
        activeCity: 0,
        showroom: {
          title: 'Шоу-рум LITHIUM',
          address: 'Вятка - Киров, ул. Казанская, 77б',
          schedule: [
            'ПН-ПТ 10.00-19.00',
            'СБ 10.00-17.00',
            'ВС Выходной'
          ],
          phone: ['+7 (8332) 711-887'],
          coords: [58.602782, 49.683750]
        },
        footer: [
          {
            key: '',
            title: '',
            value: 'Made in Russia, Kirov - Vyatka'
          },
          {
            key: '',
            title: '',
            value: '© Lithium ' + new Date().getFullYear()
          }
        ],
        phones: [
          {
            id: 1,
            city: 'Киров',
            phone: '+7 (8332) 711-887',
            phoneLink: '+78332711887'
          },
          {
            id: 2,
            city: 'Москва',
            phone: '+7 (495) 152-48-28',
            phoneLink: '+74951524828'
          },
          {
            id: 3,
            city: 'Сервисная служба',
            phone: '+7 (499) 229-86-16',
            phoneLink: '+78332711887'
          }
        ],
        slides: [
          {
            id: '01',
            title: 'LITHIUM ARTPLAY STORE',
            city: 'Москва',
            address: 'Москва, ул. Нижняя Сыромятническая, дом 10, стр. 9, 2 этаж',
            schedule: [
              {
                day: 'ПН - ПТ',
                time: '10:00 - 20:00'
              },
              {
                day: 'СБ - ВС',
                time: '11:00 - 19:00'
              }
            ],
            email: 'artplay@lithiumhome.ru',
            phone: [moscowShowroom.displayTelephone],
            phoneLink: moscowShowroom.telephone,
            coords: [55.752835, 37.667950],
            image: require('@/assets/img/showroom/1.jpg'),
            imageMob: require('@/assets/img/showroom/1mob.jpg'),
            images: [
              {
                image: require('@/assets/img/contacts/new/2_1_desktop.webp'),
                imageMob: require('@/assets/img/contacts/new/2_1_mob.webp')
              },
              {
                image: require('@/assets/img/contacts/new/2_2_desktop.webp'),
                imageMob: require('@/assets/img/contacts/new/2_2_mob.webp')
              },
              {
                image: require('@/assets/img/contacts/new/2_3_desktop.webp'),
                imageMob: require('@/assets/img/contacts/new/2_3_mob.webp')
              },
              {
                image: require('@/assets/img/contacts/new/2_4_desktop.webp'),
                imageMob: require('@/assets/img/contacts/new/2_4_mob.webp')
              }
            ]
          },
          {
            id: '02',
            title: 'LITHIUM KIROV STORE',
            city: 'Киров',
            address: 'Вятка - Киров, ул. Казанская, 77б',
            fullAddress: 'Вятка - Киров, ул. Казанская, 77б, 3 этаж',
            schedule: [
              {
                day: 'ПН-ПТ',
                time: '10:00 - 19:00'
              },
              {
                day: 'СБ-ВС',
                time: '10:00 - 17:00'
              }
            ],
            email: 'kirov@lithiumhome.ru',
            email2: 'info@lithiumhome.ru',
            phone: [kirovShowroom.displayTelephone],
            phoneLink: kirovShowroom.telephone,
            coords: [58.602782, 49.683750],
            image: require('@/assets/img/showroom/2.jpg'),
            imageMob: require('@/assets/img/showroom/2mob.jpg'),
            images: [
              {
                image: require('@/assets/img/contacts/new/3_1_desktop.webp'),
                imageMob: require('@/assets/img/contacts/new/3_1_mob.webp')
              },
              {
                image: require('@/assets/img/contacts/new/3_2_desktop.webp'),
                imageMob: require('@/assets/img/contacts/new/3_2_mob.webp')
              },
              {
                image: require('@/assets/img/contacts/new/3_3_desktop.webp'),
                imageMob: require('@/assets/img/contacts/new/3_3_mob.webp')
              },
              {
                image: require('@/assets/img/contacts/new/3_4_desktop.webp'),
                imageMob: require('@/assets/img/contacts/new/3_4_mob.webp')
              }
            ]
          }
        ]
      }
    }
  },
  actions: {
    scrollToTop ({ commit }) {
      commit('setActivePage', 0)
    },
    scrollTo ({ commit }, payload) {
      commit('setActivePage', payload)
    },
    openPopup ({ commit }) {
      commit('openPopup')
    },
    closePopup ({ commit }) {
      commit('closePopup')
    },
    activeCity ({ commit }, payload) {
      commit('activeCity', payload)
    }
  },
  mutations: {
    setActiveState (state, payload) {
      state.active = payload
    },
    setActivePage (state, page) {
      state.activePage = page
    },
    setTotalPages (state, count) {
      state.totalPages = count
    },
    openPopup (state) {
      state.openPopup = true
    },
    closePopup (state) {
      state.openPopup = false
    },
    activeCity (state, payload) {
      state.sectionsContent.contacts.activeCity = payload
    }
  },
  getters: {
    isActive: state => state.active,
    activePage: state => state.activePage,
    totalPages: state => state.totalPages,
    sectionsContent: state => state.sectionsContent
  }
}
